<form [formGroup]="editForm" (ngSubmit)="onSubmit()">
  <!-- PLAYLIST TITLE -->
  <div class="wrapper">
    <div class="label" translate>
      watch.playlist_modal.create_new_playlist_modal.labels.name
      <span class="required">*</span>
    </div>

    <div class="input-wrapper">
      <span class="icon icon-video-playlist"></span>
      <input class="input" type="text" formControlName="title" />
    </div>
  </div>

  <!-- DESCRIPION -->
  <div class="wrapper">
    <div class="label" translate>
      watch.playlist_modal.create_new_playlist_modal.labels.desc
    </div>

    <ckeditor
      class="ckdata"
      formControlName="description"
      [editor]="editor"
      [config]="config" />
    <!-- <textarea class="input" rows="6" formControlName="description"></textarea> -->
  </div>

  <!-- STATUS -->
  <div class="wrapper">
    <div class="label-wrapper">
      <div class="label" translate>
        watch.playlist_modal.create_new_playlist_modal.labels.public
      </div>
      <kin-toggle-switch
        (onClick)="switchClick()"
        [active]="isPublic"
        size="small"
        [leftText]="'settings.share.yes' | translate"
        [rightText]="'settings.share.no' | translate" />
    </div>
    <div class="hint" translate>
      watch.playlist_modal.create_new_playlist_modal.tips.public
    </div>
  </div>

  <div class="divider"></div>

  <div class="image-wrapper">
    <div class="img-placeholder banner">
      @if (bannerSrc) {
        <img [src]="bannerSrc" />
        <div class="remove" (click)="remove('banner')">
          <kin-icon name="trash" [color]="trashColor" />
        </div>
      }
      <input
        #inputBanner
        class="inputfile"
        id="bannerFile"
        type="file"
        (change)="loadImage($event, 'banner')"
        accept="image/jpeg, image/png" />

      @if (!bannerFile) {
        <label for="bannerFile" translate>
          <span class="icon icon-plus-lg"></span>
          watch.playlist_modal.create_new_playlist_modal.btn.banner
        </label>
      } @else if (!logoSrc) {
        <div class="file-name">{{ bannerFile?.name }}</div>
      }
    </div>

    <div class="logo-wrapper">
      <div class="img-placeholder logo">
        @if (logoSrc) {
          <img [src]="logoSrc" />
          <div class="remove" (click)="remove('logo')">
            <kin-icon name="trash" [color]="trashColor" />
          </div>
        }
        <input
          #inputLogo
          class="inputfile"
          id="logoFile"
          type="file"
          (change)="loadImage($event, 'logo')"
          accept="image/jpeg, image/png" />
        @if (!logoFile) {
          <label for="logoFile" translate>
            <span class="icon icon-plus-lg"></span>
          </label>
        } @else if (!logoSrc) {
          <div class="file-name">{{ logoFile?.name }}</div>
        }
      </div>
      <p class="hint" translate>
        watch.playlist_modal.create_new_playlist_modal.tips.logo
      </p>
    </div>
  </div>

  <div class="button-wrapper">
    <!-- BUTTON  -->
    <kin-btn
      extended="true"
      class="submit-btn"
      [color]="'primary'"
      [disabled]="loading$ | async"
      [type]="'submit'">
      {{ 'watch.map_player.sync_btn_save' | translate | titlecase }}
    </kin-btn>

    <kin-btn
      extended="true"
      class="submit-cancel"
      (onClick)="onCloseEdit.emit()"
      [color]="'secondary'"
      [disabled]="loading$ | async">
      {{ 'watch.map_player.sync_btn_cancel' | translate | titlecase }}
    </kin-btn>
  </div>
</form>
